// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modern Table Component Styles
 */

.modern-table-container {
  overflow-x: auto;
  border-radius: var(--radius-xl);
  border: 1px solid var(--neutral-200);
  background: white;
  box-shadow: var(--shadow-sm);
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--text-sm);
  color: var(--neutral-700);
}

/* Table Variants */
.modern-table--default {
  background: white;
}

.modern-table--elevated {
  background: white;
  box-shadow: var(--shadow-lg);
}

.modern-table--bordered {
  border: 2px solid var(--neutral-200);
}

.modern-table--minimal {
  border: none;
  box-shadow: none;
}

/* Table Header */
.modern-table__header {
  background: #252A33;
  border-bottom: 2px solid #E5E7EB;
}

.modern-table__header-cell {
  padding: var(--space-4) var(--space-6);
  text-align: left;
  font-weight: var(--font-weight-semibold);
  color: white;
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.modern-table__header-cell--center {
  text-align: center;
}

.modern-table__header-cell--right {
  text-align: right;
}

.modern-table__header-cell--sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all var(--transition-base);
}

.modern-table__header-cell--sortable:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #FDBA74;
}

.modern-table__header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.modern-table__header-text {
  flex: 1 1;
}

.modern-table__sort-icon {
  font-size: var(--text-xs);
  color: var(--neutral-400);
  transition: all var(--transition-base);
}

.modern-table__header-cell--sortable:hover .modern-table__sort-icon {
  color: #FDBA74;
}

.modern-table__header-cell--asc .modern-table__sort-icon,
.modern-table__header-cell--desc .modern-table__sort-icon {
  color: #FDBA74;
}

/* Table Body */
.modern-table__body {
  background: white;
}

.modern-table__row {
  border-bottom: 1px solid var(--neutral-100);
  transition: all var(--transition-base);
}

.modern-table__row--clickable {
  cursor: pointer;
}

.modern-table__row--clickable:hover {
  background: var(--neutral-50);
}

.modern-table__row--selected {
  background: var(--primary-50);
  border-color: var(--primary-200);
}

.modern-table__row--selected:hover {
  background: var(--primary-100);
}

/* Table Cell */
.modern-table__cell {
  padding: var(--space-4) var(--space-6);
  border-bottom: 1px solid var(--neutral-100);
  vertical-align: middle;
}

.modern-table__cell--header {
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-900);
  background: var(--neutral-50);
}

.modern-table__cell--center {
  text-align: center;
}

.modern-table__cell--right {
  text-align: right;
}

/* Striped Rows */
.modern-table--striped .modern-table__row:nth-child(even) {
  background: var(--neutral-50);
}

.modern-table--striped .modern-table__row:nth-child(even):hover {
  background: var(--neutral-100);
}

/* Hover Effect */
.modern-table--hover .modern-table__row:hover {
  background: var(--neutral-50);
}

/* Table Footer */
.modern-table__footer {
  background: var(--neutral-50);
  border-top: 2px solid var(--neutral-200);
}

.modern-table__footer .modern-table__cell {
  padding: var(--space-4) var(--space-6);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-700);
  background: var(--neutral-50);
}

/* Pagination */
.modern-table__pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-4) var(--space-6);
  background: var(--neutral-50);
  border-top: 1px solid var(--neutral-200);
  gap: var(--space-4);
}

.modern-table__pagination-info {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  font-size: var(--text-sm);
  color: var(--neutral-600);
}

.modern-table__page-size-select {
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  background: white;
  color: var(--neutral-700);
  cursor: pointer;
}

.modern-table__page-size-select:focus {
  outline: none;
  border-color: var(--primary-500);
  box-shadow: 0 0 0 2px var(--primary-100);
}

.modern-table__pagination-controls {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.modern-table__pagination-btn {
  padding: var(--space-2) var(--space-4);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  background: white;
  color: var(--neutral-700);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-base);
}

.modern-table__pagination-btn:hover:not(:disabled) {
  background: var(--neutral-50);
  border-color: var(--neutral-400);
}

.modern-table__pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modern-table__pagination-pages {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.modern-table__pagination-page {
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-md);
  background: white;
  color: var(--neutral-700);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-base);
  min-width: 40px;
  text-align: center;
}

.modern-table__pagination-page:hover {
  background: var(--neutral-50);
  border-color: var(--neutral-400);
}

.modern-table__pagination-page--active {
  background: var(--primary-500);
  border-color: var(--primary-500);
  color: white;
}

.modern-table__pagination-page--active:hover {
  background: var(--primary-600);
  border-color: var(--primary-600);
}

/* Empty State */
.modern-table__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--space-8);
  text-align: center;
  color: var(--neutral-500);
}

.modern-table__empty-icon {
  font-size: var(--text-4xl);
  margin-bottom: var(--space-4);
  opacity: 0.5;
}

.modern-table__empty-message {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-medium);
  color: var(--neutral-600);
}

/* Loading State */
.modern-table__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-16) var(--space-8);
  text-align: center;
  color: var(--neutral-500);
}

.modern-table__loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--neutral-200);
  border-top: 3px solid var(--primary-500);
  border-radius: var(--radius-full);
  animation: spin 1s linear infinite;
  margin-bottom: var(--space-4);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.modern-table__loading-message {
  font-size: var(--text-lg);
  font-weight: var(--font-weight-medium);
  color: var(--neutral-600);
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-table__pagination {
    flex-direction: column;
    gap: var(--space-4);
    align-items: stretch;
  }

  .modern-table__pagination-info {
    justify-content: center;
  }

  .modern-table__pagination-controls {
    justify-content: center;
  }

  .modern-table__pagination-pages {
    flex-wrap: wrap;
    justify-content: center;
  }

  .modern-table__header-cell,
  .modern-table__cell {
    padding: var(--space-3) var(--space-4);
  }
}

@media (max-width: 480px) {
  .modern-table__pagination-pages {
    gap: var(--space-1);
  }

  .modern-table__pagination-page {
    min-width: 32px;
    padding: var(--space-1) var(--space-2);
    font-size: var(--text-xs);
  }

  .modern-table__pagination-btn {
    padding: var(--space-1) var(--space-2);
    font-size: var(--text-xs);
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .modern-table-container {
    background: var(--neutral-800);
    border-color: var(--neutral-700);
  }

  .modern-table {
    color: var(--neutral-300);
  }

  .modern-table__header {
    background: var(--neutral-700);
  }

  .modern-table__header-cell {
    color: var(--neutral-200);
    border-color: var(--neutral-600);
  }

  .modern-table__body {
    background: var(--neutral-800);
  }

  .modern-table__row {
    border-color: var(--neutral-700);
  }

  .modern-table__row:hover {
    background: var(--neutral-700);
  }

  .modern-table__row--selected {
    background: var(--primary-900);
    border-color: var(--primary-700);
  }

  .modern-table__cell {
    border-color: var(--neutral-700);
  }

  .modern-table__cell--header {
    background: var(--neutral-700);
    color: var(--neutral-100);
  }

  .modern-table--striped .modern-table__row:nth-child(even) {
    background: var(--neutral-700);
  }

  .modern-table__footer {
    background: var(--neutral-700);
    border-color: var(--neutral-600);
  }

  .modern-table__footer .modern-table__cell {
    background: var(--neutral-700);
    color: var(--neutral-200);
  }

  .modern-table__pagination {
    background: var(--neutral-700);
    border-color: var(--neutral-600);
  }

  .modern-table__page-size-select {
    background: var(--neutral-800);
    border-color: var(--neutral-600);
    color: var(--neutral-200);
  }

  .modern-table__pagination-btn,
  .modern-table__pagination-page {
    background: var(--neutral-800);
    border-color: var(--neutral-600);
    color: var(--neutral-200);
  }

  .modern-table__pagination-btn:hover:not(:disabled),
  .modern-table__pagination-page:hover {
    background: var(--neutral-700);
    border-color: var(--neutral-500);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ModernTable.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,sCAAsC;IACtC,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;;IAEE,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;;IAEE,8BAA8B;IAC9B,gCAAgC;EAClC;AACF","sourcesContent":["/**\n * Modern Table Component Styles\n */\n\n.modern-table-container {\n  overflow-x: auto;\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--neutral-200);\n  background: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.modern-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--text-sm);\n  color: var(--neutral-700);\n}\n\n/* Table Variants */\n.modern-table--default {\n  background: white;\n}\n\n.modern-table--elevated {\n  background: white;\n  box-shadow: var(--shadow-lg);\n}\n\n.modern-table--bordered {\n  border: 2px solid var(--neutral-200);\n}\n\n.modern-table--minimal {\n  border: none;\n  box-shadow: none;\n}\n\n/* Table Header */\n.modern-table__header {\n  background: #252A33;\n  border-bottom: 2px solid #E5E7EB;\n}\n\n.modern-table__header-cell {\n  padding: var(--space-4) var(--space-6);\n  text-align: left;\n  font-weight: var(--font-weight-semibold);\n  color: white;\n  font-size: var(--text-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n}\n\n.modern-table__header-cell--center {\n  text-align: center;\n}\n\n.modern-table__header-cell--right {\n  text-align: right;\n}\n\n.modern-table__header-cell--sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: all var(--transition-base);\n}\n\n.modern-table__header-cell--sortable:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #FDBA74;\n}\n\n.modern-table__header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-2);\n}\n\n.modern-table__header-text {\n  flex: 1;\n}\n\n.modern-table__sort-icon {\n  font-size: var(--text-xs);\n  color: var(--neutral-400);\n  transition: all var(--transition-base);\n}\n\n.modern-table__header-cell--sortable:hover .modern-table__sort-icon {\n  color: #FDBA74;\n}\n\n.modern-table__header-cell--asc .modern-table__sort-icon,\n.modern-table__header-cell--desc .modern-table__sort-icon {\n  color: #FDBA74;\n}\n\n/* Table Body */\n.modern-table__body {\n  background: white;\n}\n\n.modern-table__row {\n  border-bottom: 1px solid var(--neutral-100);\n  transition: all var(--transition-base);\n}\n\n.modern-table__row--clickable {\n  cursor: pointer;\n}\n\n.modern-table__row--clickable:hover {\n  background: var(--neutral-50);\n}\n\n.modern-table__row--selected {\n  background: var(--primary-50);\n  border-color: var(--primary-200);\n}\n\n.modern-table__row--selected:hover {\n  background: var(--primary-100);\n}\n\n/* Table Cell */\n.modern-table__cell {\n  padding: var(--space-4) var(--space-6);\n  border-bottom: 1px solid var(--neutral-100);\n  vertical-align: middle;\n}\n\n.modern-table__cell--header {\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-900);\n  background: var(--neutral-50);\n}\n\n.modern-table__cell--center {\n  text-align: center;\n}\n\n.modern-table__cell--right {\n  text-align: right;\n}\n\n/* Striped Rows */\n.modern-table--striped .modern-table__row:nth-child(even) {\n  background: var(--neutral-50);\n}\n\n.modern-table--striped .modern-table__row:nth-child(even):hover {\n  background: var(--neutral-100);\n}\n\n/* Hover Effect */\n.modern-table--hover .modern-table__row:hover {\n  background: var(--neutral-50);\n}\n\n/* Table Footer */\n.modern-table__footer {\n  background: var(--neutral-50);\n  border-top: 2px solid var(--neutral-200);\n}\n\n.modern-table__footer .modern-table__cell {\n  padding: var(--space-4) var(--space-6);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-700);\n  background: var(--neutral-50);\n}\n\n/* Pagination */\n.modern-table__pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-4) var(--space-6);\n  background: var(--neutral-50);\n  border-top: 1px solid var(--neutral-200);\n  gap: var(--space-4);\n}\n\n.modern-table__pagination-info {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  font-size: var(--text-sm);\n  color: var(--neutral-600);\n}\n\n.modern-table__page-size-select {\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--neutral-300);\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm);\n  background: white;\n  color: var(--neutral-700);\n  cursor: pointer;\n}\n\n.modern-table__page-size-select:focus {\n  outline: none;\n  border-color: var(--primary-500);\n  box-shadow: 0 0 0 2px var(--primary-100);\n}\n\n.modern-table__pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.modern-table__pagination-btn {\n  padding: var(--space-2) var(--space-4);\n  border: 1px solid var(--neutral-300);\n  border-radius: var(--radius-md);\n  background: white;\n  color: var(--neutral-700);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.modern-table__pagination-btn:hover:not(:disabled) {\n  background: var(--neutral-50);\n  border-color: var(--neutral-400);\n}\n\n.modern-table__pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.modern-table__pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n.modern-table__pagination-page {\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--neutral-300);\n  border-radius: var(--radius-md);\n  background: white;\n  color: var(--neutral-700);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  min-width: 40px;\n  text-align: center;\n}\n\n.modern-table__pagination-page:hover {\n  background: var(--neutral-50);\n  border-color: var(--neutral-400);\n}\n\n.modern-table__pagination-page--active {\n  background: var(--primary-500);\n  border-color: var(--primary-500);\n  color: white;\n}\n\n.modern-table__pagination-page--active:hover {\n  background: var(--primary-600);\n  border-color: var(--primary-600);\n}\n\n/* Empty State */\n.modern-table__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-16) var(--space-8);\n  text-align: center;\n  color: var(--neutral-500);\n}\n\n.modern-table__empty-icon {\n  font-size: var(--text-4xl);\n  margin-bottom: var(--space-4);\n  opacity: 0.5;\n}\n\n.modern-table__empty-message {\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-medium);\n  color: var(--neutral-600);\n}\n\n/* Loading State */\n.modern-table__loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-16) var(--space-8);\n  text-align: center;\n  color: var(--neutral-500);\n}\n\n.modern-table__loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--neutral-200);\n  border-top: 3px solid var(--primary-500);\n  border-radius: var(--radius-full);\n  animation: spin 1s linear infinite;\n  margin-bottom: var(--space-4);\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.modern-table__loading-message {\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-medium);\n  color: var(--neutral-600);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .modern-table__pagination {\n    flex-direction: column;\n    gap: var(--space-4);\n    align-items: stretch;\n  }\n\n  .modern-table__pagination-info {\n    justify-content: center;\n  }\n\n  .modern-table__pagination-controls {\n    justify-content: center;\n  }\n\n  .modern-table__pagination-pages {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .modern-table__header-cell,\n  .modern-table__cell {\n    padding: var(--space-3) var(--space-4);\n  }\n}\n\n@media (max-width: 480px) {\n  .modern-table__pagination-pages {\n    gap: var(--space-1);\n  }\n\n  .modern-table__pagination-page {\n    min-width: 32px;\n    padding: var(--space-1) var(--space-2);\n    font-size: var(--text-xs);\n  }\n\n  .modern-table__pagination-btn {\n    padding: var(--space-1) var(--space-2);\n    font-size: var(--text-xs);\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .modern-table-container {\n    background: var(--neutral-800);\n    border-color: var(--neutral-700);\n  }\n\n  .modern-table {\n    color: var(--neutral-300);\n  }\n\n  .modern-table__header {\n    background: var(--neutral-700);\n  }\n\n  .modern-table__header-cell {\n    color: var(--neutral-200);\n    border-color: var(--neutral-600);\n  }\n\n  .modern-table__body {\n    background: var(--neutral-800);\n  }\n\n  .modern-table__row {\n    border-color: var(--neutral-700);\n  }\n\n  .modern-table__row:hover {\n    background: var(--neutral-700);\n  }\n\n  .modern-table__row--selected {\n    background: var(--primary-900);\n    border-color: var(--primary-700);\n  }\n\n  .modern-table__cell {\n    border-color: var(--neutral-700);\n  }\n\n  .modern-table__cell--header {\n    background: var(--neutral-700);\n    color: var(--neutral-100);\n  }\n\n  .modern-table--striped .modern-table__row:nth-child(even) {\n    background: var(--neutral-700);\n  }\n\n  .modern-table__footer {\n    background: var(--neutral-700);\n    border-color: var(--neutral-600);\n  }\n\n  .modern-table__footer .modern-table__cell {\n    background: var(--neutral-700);\n    color: var(--neutral-200);\n  }\n\n  .modern-table__pagination {\n    background: var(--neutral-700);\n    border-color: var(--neutral-600);\n  }\n\n  .modern-table__page-size-select {\n    background: var(--neutral-800);\n    border-color: var(--neutral-600);\n    color: var(--neutral-200);\n  }\n\n  .modern-table__pagination-btn,\n  .modern-table__pagination-page {\n    background: var(--neutral-800);\n    border-color: var(--neutral-600);\n    color: var(--neutral-200);\n  }\n\n  .modern-table__pagination-btn:hover:not(:disabled),\n  .modern-table__pagination-page:hover {\n    background: var(--neutral-700);\n    border-color: var(--neutral-500);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
